import React, { useState, useEffect,useRef } from 'react';
import {urlApiProd,print,correoUsuario,formatYYYYMMDD,capitalizeFirstLetter,handleEliminar,handleAgregar} from '../utiles';
import DateInput from '../../components/DateInput/DateInput';
import { Modal, Button, Spinner, Badge, Card,Form,Row,Alert,Table,Container,Col,InputGroup,Accordion,ListGroup } from 'react-bootstrap';
import moment from 'moment';
import { IoTrashOutline,IoDownloadOutline } from "react-icons/io5";
import { toast, ToastContainer } from 'react-toastify';
import DataTable from 'react-data-table-component';
import { LuPencilLine } from "react-icons/lu";


const GestionCPO = ({ desde, solicitud, puertos, ffw, carriers,  cerrar }) => {
const [formDataAntigua, setFormDataAntigua] = useState({ ...solicitud });
const [formData, setFormData] = useState({ ...solicitud });
const clienteInternoId = solicitud?.solicitud_interna?.id_cliente;
const [show, setShow] = React.useState(true);
const [dataHistoria, setdataHistoria] = useState([]);
const [usuarioCreador, setUsuarioCreador] = React.useState(undefined);
const [mapa,setMAPA] = React.useState(solicitud.mapa);
const [erroresForm, seterroresForm] = useState('');
const [showguardarArchivo, setShowguardarArchivo] = React.useState(false);
const [dataDocumentos,setDocumentos] = useState([]);
const [dataClientes,setClientes] = useState([]);
const [dataProformas,setProformas] = useState([]);
const [dataClientesBooking,setClientesBooking] = useState([]);
const [dataProveedores,setProveedores] = useState([]);
const [DataBookingProveedores,setDataBookingProveedores] = useState([]);
const [loading, setLoading] = useState(true);
const [DataBookingProformas,setDataBookingProformas] = useState([]);
const [dataNombresProductos,setDataNombresProductos] = useState([]);
const [dataBookingProducto,setDataBookingProducto] = useState([]);
const [dataBookingContenedor,setDataBookingContenedor] = useState([]);
const cantidadHCAsignada = dataBookingContenedor.reduce(
  (total, asignacion) => total + (Number(asignacion.cantidad_contenedores) || 0),
  0
);
const cantidadHCPendiente = Math.max(0, (Number(formData.cantidad) || 0) - cantidadHCAsignada);
const [nombreContenedor, setnombreContenedor] = useState('');
const [fechaRetiro, setfechaRetiro] = useState(undefined);
const [fechaIngresoPuerto, setfechaIngresoPuerto] = useState(undefined);
const [dataBookingFecha,setDataBookingFecha] = useState([]);

  useEffect(() => {
    fetchDataClientes();
    if (desde === 'solicitudesinternas') fetchDataProformas();
    fetchDataProveedores();
    fetchDataNombreProductos();
    fetchDataBookingContenedor();
    fetchDataBookingFecha();
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    fetchDataDocumentos();
    fetchDataHistoria();

setLoading(false);

  };

  const fetchDataBookingFecha = async () => {
    const token = localStorage.getItem('token');
    try {
        // Fetch Solicitudes Internas
        const response = await fetch(`${urlApiProd}/bookingfecha/${formData.id_solicitud}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error fetching setDataBookingFecha');
        const data = await response.json();
        setDataBookingFecha(data);
    } catch (error) {
        console.error('Error en fetchData:', error.message);
        toast.error(`setDataBookingFecha no cargados: ${error.message}`, { toastId: 'error-principal' });
    }
};
  
  const fetchDataBookingContenedor = async () => {
    const token = localStorage.getItem('token');
    try {
        // Fetch Solicitudes Internas
        const response = await fetch(`${urlApiProd}/bookingclientecontenedor/${formData.id_solicitud}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error fetching setDataBookingContenedor');
        const data = await response.json();
        setDataBookingContenedor(data);
    } catch (error) {
        console.error('Error en fetchData:', error.message);
        toast.error(`setDataBookingContenedor no cargados: ${error.message}`, { toastId: 'error-principal' });
    }
};

  const fetchDataNombreProductos = async () => {
    const token = localStorage.getItem('token');
    try {
        // Fetch Solicitudes Internas
        const response = await fetch(`${urlApiProd}/nombreproductos_ordencompra`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error fetching fetchDataNombreProductos');
        const data = await response.json();
        setDataNombresProductos(data);
    } catch (error) {
        console.error('Error en fetchData:', error.message);
        toast.error(`fetchDataNombreProductos no cargados: ${error.message}`, { toastId: 'error-principal' });
    }
};

  const fetchDataBookingProformas = async () => {
    const token = localStorage.getItem('token');
    try {
        // Fetch Solicitudes Internas
        const response = await fetch(`${urlApiProd}/bookingproforma/${formData.id_solicitud}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error fetching DataBookingProveedores');
        const data = await response.json();
        setDataBookingProformas(data);
    } catch (error) {
        console.error('Error en fetchData:', error.message);
        toast.error(`DataBookingProveedores no cargados: ${error.message}`, { toastId: 'error-principal' });
    }
};

  const fetchDataBookingProveedor = async () => {
    const token = localStorage.getItem('token');
    try {
        // Fetch Solicitudes Internas
        const response = await fetch(`${urlApiProd}/bookingproveedores/${formData.id_solicitud}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error fetching DataBookingProveedores');
        const data = await response.json();
        setDataBookingProveedores(data);
    } catch (error) {
        console.error('Error en fetchData:', error.message);
        toast.error(`DataBookingProveedores no cargados: ${error.message}`, { toastId: 'error-principal' });
    }
};

const fetchDataProveedores = async () => {
    const token = localStorage.getItem('token');
    try {
        // Fetch Solicitudes Internas
        const response = await fetch(`${urlApiProd}/proveedores`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error fetching proveedores');
        const data = await response.json();
        setProveedores(data);
    } catch (error) {
        console.error('Error en fetchData:', error.message);
        toast.error(`proveedores no cargados: ${error.message}`, { toastId: 'error-principal' });
    }
};

const fetchDataClientesBooking = async () => {
    const token = localStorage.getItem('token');
    try {
        // Fetch Solicitudes Internas
        const response = await fetch(`${urlApiProd}/bookingclientesbooking/${formData.id_solicitud}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error fetching bookingclientesbooking');
        const data = await response.json();
        setClientesBooking(data);
    } catch (error) {
        console.error('Error en fetchData:', error.message);
        toast.error(`bookingclientesbooking no cargados: ${error.message}`, { toastId: 'error-principal' });
    }
    
};

const fetchDataClientes = async () => {
    const token = localStorage.getItem('token');
    try {
        // Fetch Solicitudes Internas
        const response = await fetch(`${urlApiProd}/clientes`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error fetching clientes');
        const data = await response.json();
        setClientes(data);
    } catch (error) {
        console.error('Error en fetchData:', error.message);
        toast.error(`clientes no cargados: ${error.message}`, { toastId: 'error-principal' });
    } 
};

const fetchDataProformas = async () => {
    const token = localStorage.getItem('token');
    try {
        const response = await fetch(`${urlApiProd}/proformas`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error fetching proformas');
        setProformas(await response.json());
    } catch (error) {
        console.error('Error en fetchDataProformas:', error.message);
        toast.error(`Proformas no cargadas: ${error.message}`, { toastId: 'error-proformas' });
    }
};
      
const handleCloseguardarArchivo = () => {
    fetchDataDocumentos();
    setShowguardarArchivo(false);};
const handleShowguardarArchivo = () => setShowguardarArchivo(true);

function timeout(delay) {
    return new Promise( res => setTimeout(res, delay) );
}

const handleUploadFileServer = async (e) => {
    const file = e.target.files[0];
    print(file);

    if(file.size<5000000){
        const token = localStorage.getItem('token');
    const fd = new FormData()
    fd.append('file', file)
    fd.append('nombre',file.name)
    fd.append('ruta','bookingexterno')
    fd.append('idObjeto',formData.id_solicitud)
    fd.append('usuario_creador',localStorage.getItem('ID_Usuario'))
    fd.append('mail_usuario_creador',localStorage.getItem('correo'))

    const response = await fetch(`${urlApiProd}/subirarchivo`, {
        headers: { 'Authorization': `Bearer ${token}` },
        method: "POST",
        body: fd
    });

    if (response.ok){
    var r = await response.json();
    print(`response ${JSON.stringify(r)}`);
    alert("Archivo guardado correctamente");
    fetchDataDocumentos();

    } else{
        print("error subiendo archivo");
    }
    
} else{
    alert("Archivo muy grande, favor comprimir o disminuir tamaño. Max 5MB");
}
        
}

const GuardarArchivo = () => {

        return (
          <>
            <Button variant="primary"  style={{marginTop:5, width:200}} onClick={handleShowguardarArchivo}>
                    Documentación de Booking
             </Button>
      
            <Modal size='lg' show={showguardarArchivo} onHide={handleCloseguardarArchivo} backdrop="static">
              <Modal.Header closeButton>
                <Modal.Title>Documentación de Booking</Modal.Title>
              </Modal.Header>
              <Modal.Body>
              <DataTable
                                columns={columns}
                                data={dataDocumentos}
                                pagination
                                paginationPerPage={10}
                                highlightOnHover
                                responsive
                            />
                            <p></p>
              Cargar nuevo archivo          
              <input type="file" onChange={handleUploadFileServer} />
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseguardarArchivo}>
                  Volver
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        );
      };

          const fetchDataDocumentos = async () => {
              const token = localStorage.getItem('token');
              try {
                  // Fetch Solicitudes Internas
                  const responsedocumentos = await fetch(`${urlApiProd}/documentosbooking`, {
                      headers: { 'Authorization': `Bearer ${token}` }
                  });
                  if (!responsedocumentos.ok) throw new Error('Error fetching preciosfletes');
                  const data= await responsedocumentos.json();
                  setDocumentos(data);
              } catch (error) {
                  console.error('Error en fetchData:', error.message);
                  toast.error(`documentos no cargados: ${error.message}`, { toastId: 'error-principal' });
              } finally{return true;}
          };



const fetchDataHistoria = async () => {
    setUsuarioCreador(await correoUsuario(formData.id_creador));
            const token = localStorage.getItem('token');
            try {
                // Fetch Solicitudes Internas
                const response = await fetch(`${urlApiProd}/historias/booking/${formData.id_solicitud}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (!response.ok) throw new Error('Error fetching datos hisotrias');
                const data= await response.json();
                data.reverse();
                //print(`'Edata:', ${data}`);
                setdataHistoria(data);
                //setTotalItems(total);
                //setPrincipal(true);
            } catch (error) {
                print(`'Error en fetchData:', ${error.message}`);
                //setPrincipal(false); // Indica que la solicitud principal falló
                print(`historias no cargadas: ${error.message} { toastId: 'error-principal' }`);
            }
        };

const handleDownloadFile = async (row) => {
    const token = localStorage.getItem('token');
    try {
        const response = await fetch(`${urlApiProd}/descargardocumento/${row.id}`, {
            method: 'POST',
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) {throw new Error('Error descargando documento');}
        else {


            const buffer = await response.arrayBuffer();
            const bytes = new Uint8Array(buffer);
            const blob = new Blob([bytes]);
            const formatedURL = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = formatedURL;
            link.setAttribute('download',row.nombre);
            document.body.appendChild(link);
            link.click();

            //print(`descargado ok ${bytes}`);
        }

        //fetchDataDocumentos();
    } catch (error) {
        console.error('Error:', error);
        alert('No fue posible descargar documento');
    }
}

        const columns = [
            { name: 'Nombre', selector: row => row.nombre,  sortable: true,reorder: true },
            { name: 'Fecha Creación', selector: row => row.fecha_creacion ? formatYYYYMMDD(row.fecha_creacion) : '',  sortable: true,reorder: true },
            { name: 'Usuario Creador', selector: row => row.mail_usuario_creador,  sortable: true,reorder: true },
            { name: 'Acciones',
                        cell: row => (
                            <div >
                                 <button className='btn btn-outline-primary mr-2' onClick={() => handleDownloadFile(row)} style={{ flex: 1, marginRight: 10 }}>
                                                            <IoDownloadOutline />
                                                        </button>
                                    <button
                                        className='btn btn-outline-danger'
                                        onClick={() => {
                                            if (window.confirm('¿Estás seguro de eliminar documento?')) {
                                                handleEliminarDoc(row.id);
                                            }
                                        }} 
                                    >
                                        <IoTrashOutline />
                                    </button>
                                   
                            </div>
                        ),
                        ignoreRowClick: true,
                    }
        ];   
        
              const handleEliminarDoc = async (id) => {
                const token = localStorage.getItem('token');
                try {
                    const response = await fetch(`${urlApiProd}/eliminardocumentobooking/${id}`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                        body: JSON.stringify({
                            usuario_elimina: localStorage.getItem('ID_Usuario')
                        }),

                    });
                    if (!response.ok) throw new Error('Error eliminando documento');
                    alert('Documento eliminado exitosamente');
                    fetchDataDocumentos();
                    return true;
                } catch (error) {
                    console.error('Error:', error);
                    alert('No se pudo eliminar documento');
                }
            };

    const handleClose = () => {setShow(false);
        cerrar();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        //print(`name ${name} value ${value} `);
    };

    const handleChangeUpperCase = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value.toUpperCase() });
    };

    const handleChangeCantidad = (e, maxi) => {
        const { name, value,min,max } = e.target;
        var value1 = 0;

        if(Number(value)<Number(maxi)){
            value1 = Number(value);     
            setFormData({ ...formData, [name]: value1>0 ? Number(value1) : '' });
        }
    }

    const handleChangeCantidadInvoice = (e, maxi) => {
        const { name, value,min,max } = e.target;
        var value1 = 0;

        if(Number(value)<Number(maxi)){
            value1 = Number(value);     
            setFormData({ ...formData, [name]: value1>0 ? Number(value1) : '' });
        }
    }


    const handleSubmit = async (e) => {
        e?.preventDefault?.();
        if (!formData.codigo.trim() || formData.id_puerto_origen===-1 || formData.id_puerto_destino===-1 || !formData.etd || !formData.cantidad || !formData.flete || formData.id_carrier===-1 || !formData.cantidad) {
            // alert('Por favor, complete todos los campos obligatorios.');
             seterroresForm('⚠️ Favor revisar información ⚠️');
             await timeout(2000);
             seterroresForm('');
             return;
         }

         if (Number(formDataAntigua.estado) !== 3 && Number(formData.estado) === 3 && cantidadHCAsignada !== Number(formData.cantidad)) {
            seterroresForm(`⚠️ Para embarcar debe asignar todos los HC (${cantidadHCAsignada}/${Number(formData.cantidad) || 0}) ⚠️`);
            await timeout(2500);
            seterroresForm('');
            return;
         }

         if (Number(formData.cantidad) < cantidadHCAsignada) {
            seterroresForm(`⚠️ Ya hay ${cantidadHCAsignada} HC asignados; no puede reducir la cantidad por debajo de ese total ⚠️`);
            await timeout(2500);
            seterroresForm('');
            return;
         }

         if(((formData.categoria_booking==='' || formData.categoria_booking===null || formData.categoria_booking===-1)) && formData.estado.toString()==="3"){
            seterroresForm('⚠️ Falta Categoría de Booking ⚠️');
             await timeout(2000);
             seterroresForm('');
             return;
         }

         
         if(((formData.mapa==='' || formData.mapa===null || formData.mapa===-1)) && formData.estado.toString()==="3"){
            seterroresForm('⚠️ Falta Indicar MAPA ⚠️');
             await timeout(2000);
             seterroresForm('');
             return;
         }

         /*
         const found = arr.some(el => el.username === name);
         if(formData.invoice.toString()!=='0' && !found){

         }
         */
         if(formData.invoice===''){
          formData.invoice=0;
    }
         if(formData.dlc===''){
            formData.dlc=null;
      }
      if(formData.dld===''){
        formData.dld=null;
  }
  if(formData.eta===''){
    formData.eta=null;
}
  if(formData.estado_bl===''){
    formData.estado_bl=null;
}



        const token = localStorage.getItem('token');

       var tifOptions = [];

        Object.keys(formDataAntigua).forEach(function(key) {
            if(key!=='solicitud_interna' && formDataAntigua[key]!==formData[key])
                tifOptions.push("algo"); 
        });

        print(`tifOptions ${tifOptions.length}`);

     //if  
     if(tifOptions.length>0){
        try {
            const response = await fetch(`${urlApiProd}/editsolicitudbooking/${solicitud.id_solicitud}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(formData)
            });


            if (response.ok){ 
                print(moment());
                print(JSON.stringify({tabla : 'booking', objeto_anterior : JSON.stringify(formDataAntigua), objeto_actual: JSON.stringify(formData), fecha: moment(), usuario_modifica: localStorage.getItem('correo'), usuario_modifica_id : localStorage.getItem('ID_Usuario'), id_objeto: formData.id_solicitud}));
                try {
                    const response1 = await fetch(`${urlApiProd}/add_historia`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                        body: JSON.stringify({tabla : 'booking', objeto_anterior : JSON.stringify(formDataAntigua), objeto_actual: JSON.stringify(formData), fecha: moment(), usuario_modifica: localStorage.getItem('correo'), usuario_modifica_id : localStorage.getItem('ID_Usuario'), id_objeto: formData.id_solicitud})
                    });
        
        
                    if (response1.ok){ 
        
                        alert('Solicitud editada exitosamente');
        
                    } else { 

                    //throw new Error('Error al editar la solicitud');
                    alert('Error al crear historia');
                     }
        
        
                    cerrar();
                } catch (error) {
                    console.error('Error:', error);
                }

            } else {
              const r = await response.json();
                print(`response ${r.error}`); 
            //throw new Error('Error al editar la solicitud');
            alert(r.error);
             }


           // cerrar();
        } catch (error) {
            console.error('Error:', error);
            alert('No se pudo editar la solicitud');
        }
    } else{
        seterroresForm('⚠️ No hay cambios realizados ⚠️');
        await timeout(2000);
        seterroresForm('');
    }

    };

    const handleChangeLimited = (e, max) => {
        const { name, value } = e.target;
    
        // Asegurar que no supere el máximo permitido
        if (value <= max) {
            setFormData({
                ...formData,
                [name]: value,
            });
        } else {
            alert(`El valor máximo permitido es ${max} días.`);
        }
    };

    //console.log("ID FFW:", formData.id_ffw);
    //clientes
    const [results, setResults] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [name, setName] = useState(solicitud?.solicitud_interna?.cliente_nombre || "");
    const [isNameSelected, setIsNameSelected] = useState(Boolean(solicitud?.solicitud_interna?.id_cliente));
    const [containers, setContainers] = useState("");

    //proveedores
    const [resultsproveedores, setResultsproveedores] = useState([]);
    const [nameproveedores, setNameproveedores] = useState("");
    const [isNameSelectedproveedores, setIsNameSelectedproveedores] = useState(false);
    const [proveedorDropdownAbierto, setProveedorDropdownAbierto] = useState(false);
    const [containersproveedores, setContainersproveedores] = useState("");

    //proforma
    const [containersproforma, setContainersproforma] = useState("");
    const [proformaID, setProformaID] = useState("");
    const [piContratoBusqueda, setPiContratoBusqueda] = useState("");
    const [piContratoSeleccionado, setPiContratoSeleccionado] = useState(null);
    const [piContratoDropdownAbierto, setPiContratoDropdownAbierto] = useState(false);

    // OC de la PI elegida: los HC se asignan a una OC concreta
    const [ordenesCompraPi, setOrdenesCompraPi] = useState([]);
    const [ordenCompraId, setOrdenCompraId] = useState('');
    useEffect(() => {
        setOrdenCompraId('');
        if (!piContratoSeleccionado?.id_proforma) {
            setOrdenesCompraPi([]);
            return;
        }
        const token = localStorage.getItem('token');
        fetch(`${urlApiProd}/proformas/${piContratoSeleccionado.id_proforma}/ordenescompra`, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
            .then((res) => (res.ok ? res.json() : []))
            .then((datos) => setOrdenesCompraPi(Array.isArray(datos) ? datos : []))
            .catch(() => setOrdenesCompraPi([]));
    }, [piContratoSeleccionado]);

        //producto
        const [resultsproducto, setResultsproducto] = useState([]);
    const [nameproducto, setNameproducto] = useState("");
    const [isNameSelectedproducto, setIsNameSelectedproducto] = useState(false);
    const [productoDropdownAbierto, setProductoDropdownAbierto] = useState(false);
    const [containersproducto, setContainersproducto] = useState("");

    useEffect(() => {
      if (clienteInternoId && dataClientes.length > 0) {
        const clienteInterno = dataClientes.find(cliente => Number(cliente.id_cliente) === Number(clienteInternoId));
        if (clienteInterno) {
          setName(clienteInterno.nombre);
          setIsNameSelected(true);
        }
      }
    }, [clienteInternoId, dataClientes]);
  
      const mockResultsClientes = (keyword) => {
        return new Promise((res, rej) => {
          setTimeout(() => {
            const searchResults = dataClientes.filter((item) => item.nombre.toUpperCase().includes(keyword.toUpperCase()));
            res(searchResults);
          }, 500);
        });
      };

      const mockResultsProveedores = (keyword) => {
        return new Promise((res, rej) => {
          setTimeout(() => {
            const searchResults = dataProveedores.filter((item) => item.nombre.toUpperCase().includes(keyword.toUpperCase()));
            res(searchResults);
          }, 500);
        });
      };

      const handleInputChange = (e,tipo) => {
        const nameValue = e.target.value;

        if(tipo==='cliente'){
        setName(nameValue);
        setIsNameSelected(false);
        setResults([]);
        setPiContratoBusqueda('');
        setPiContratoSeleccionado(null);
        setNameproducto('');
        setIsNameSelectedproducto(false);
        setResultsproducto([]);
        setProductoDropdownAbierto(false);
        } else if(tipo==='proveedor'){
            setNameproveedores(nameValue);
            setIsNameSelectedproveedores(false);
            setResultsproveedores([]);
            setProveedorDropdownAbierto(nameValue.length > 0);
        } else if(tipo==='producto'){
            setNameproducto(nameValue);
            setIsNameSelectedproducto(false);
            const productosPermitidos = new Set(
              (piContratoSeleccionado?.productos || []).map(id => Number(id))
            );
            setResultsproducto(dataNombresProductos.filter((item) =>
              productosPermitidos.has(Number(item.id_producto)) &&
              item.nombre_producto.toUpperCase().includes(nameValue.toUpperCase())
            ));
            setProductoDropdownAbierto(true);
            return;
        }

        if (nameValue.length > 1) {
          setIsLoading(true);
          if(tipo==='cliente'){
          mockResultsClientes(nameValue)
            .then((res) => {
              setResults(res);
              setIsLoading(false);
            })
            .catch(() => {
              setIsLoading(false);
            });}
            else if(tipo==='proveedor'){
                mockResultsProveedores(nameValue)
                  .then((res) => {
                    setResultsproveedores(res);
                    setProveedorDropdownAbierto(true);
                    setIsLoading(false);
                  })
                  .catch(() => {
                    setIsLoading(false);
                  });}
        }
      };
    
      const seleccionarOrdenCompra = (id) => {
        setOrdenCompraId(id);
        const oc = ordenesCompraPi.find((o) => String(o.id_ordencompra) === String(id));
        if (oc) {
            setNameproveedores(oc.proveedor || '');
            setIsNameSelectedproveedores(true);
            setResultsproveedores([]);
            setProveedorDropdownAbierto(false);
        }
      };

      const onNameSelected = (selectedName,tipo) => {
        if(tipo==='cliente'){
        setName(selectedName);
        setIsNameSelected(true);
        setResults([]);
        setPiContratoBusqueda('');
        setPiContratoSeleccionado(null);
        setNameproducto('');
        setIsNameSelectedproducto(false);
        setResultsproducto([]);
        setProductoDropdownAbierto(false);
        }
        else if(tipo==='proveedor'){
            setNameproveedores(selectedName);
        setIsNameSelectedproveedores(true);
        setResultsproveedores([]);
        setProveedorDropdownAbierto(false);
        }
        else if(tipo==='producto'){
            setNameproducto(selectedName);
        setIsNameSelectedproducto(true);
        setResultsproducto([]);
        setProductoDropdownAbierto(false);
        }
      };

      const handleChangeConteiner = (e,tipo) => {
        const { name, value } = e.target;

        if(tipo==='cliente')
        setContainers(value);
        else if(tipo==='proveedor')
        setContainersproveedores(value);       
        else if(tipo==='proforma')
        setContainersproforma(value);   
        else if(tipo==='producto')
            setContainersproducto(value);   
    };
 

      const handleAgregarCliente = async () => {

        const idCliente = name!=='' ? dataClientes.find((item) => item.nombre===name)?.id_cliente : -1;

            print(`handleAgregarCliente containers ${containers} cliente ${idCliente}`);

const token = localStorage.getItem('token');
if(idCliente!==-1){
        try {
            const response = await fetch(`${urlApiProd}/addbookingcliente`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    'id_booking' : formData.id_solicitud,
                    'id_cliente' : idCliente,
                    'cantidad_contenedores' : containers,
                })
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Error al agregar registro');
            } else{
                fetchDataClientesBooking();
                setContainers('');
                setName('');
                setIsNameSelected(false);

                const respuesta = await response.json();
                print(`response.json() ${respuesta.id}`);
            }
        }
            catch(error){
            print(`Error: ${error}`);
            alert('No se pudo agregar la registro');
            }} else{
                alert('No se pudo agregar registro');
            }

      };

      const clienteAsignacionId = clienteInternoId || dataClientes.find(item => item.nombre === name)?.id_cliente;
      const proformasDelCliente = dataProformas.filter(proforma =>
        clienteAsignacionId &&
        Number(proforma.cliente) === Number(clienteAsignacionId) &&
        proforma.correlativo !== null &&
        proforma.correlativo !== undefined &&
        proforma.id_pi
      );
      const resultadosProformas = proformasDelCliente.filter(proforma => {
        const normalize = value => String(value).toLocaleLowerCase().replace(/\s+/g, '');
        const query = normalize(piContratoBusqueda.trim());
        return !query ||
          normalize(proforma.id_pi).includes(query) ||
          String(proforma.correlativo).includes(query);
      }).slice(0, 30);

      const seleccionarProforma = (proforma) => {
        setPiContratoSeleccionado(proforma);
        setPiContratoBusqueda(proforma.id_pi);
        setPiContratoDropdownAbierto(false);
        setNameproducto('');
        setIsNameSelectedproducto(false);
        setResultsproducto([]);
        setProductoDropdownAbierto(false);
      };

      const mostrarContratoAsignado = (asignacion) => {
        const proforma = dataProformas.find(item =>
          Number(item.cliente) === Number(asignacion.id_cliente) &&
          Number(item.correlativo) === Number(asignacion.correlativo_contrato)
        );
        return proforma?.id_pi || asignacion.correlativo_contrato;
      };

      const handlePiContratoKeyDown = (e) => {
        if (e.key === 'Escape') {
          setPiContratoDropdownAbierto(false);
        } else if (e.key === 'Enter' && piContratoDropdownAbierto && resultadosProformas.length > 0) {
          e.preventDefault();
          seleccionarProforma(resultadosProformas[0]);
        }
      };

      const handleAgregarProveedor = async () => {

        const id = nameproveedores!=='' ? dataProveedores.find((item) => item.nombre===nameproveedores)?.id_proveedor : -1;

            print(`handleAgregarProveedor containers ${containersproveedores} cliente ${id}`);

            if(id!==-1){
            const data = JSON.stringify({
                'id_booking' : formData.id_solicitud,
                'id_proveedor' : id,
                'cantidad_contenedores' : containersproveedores,
                'reducido' : 'no',
                'motivo' : '',
            });

          const resultado =  await handleAgregar('addbookingproveedor',data);
          if(resultado==="Agregado correctamente"){
            fetchDataBookingProveedor();
                setContainersproveedores('');
                setNameproveedores('');
                setIsNameSelectedproveedores(false);
          }
          alert(resultado);
        } else{alert("No fue posible agregar registro");}
      };

      const handleAgregarProforma = async () => {

            print(`handleAgregarProforma containers ${containersproforma} n° proforma ${proformaID}`);

            const data = JSON.stringify({
                'id_booking' : formData.id_solicitud,
                'correlativo_proforma' : proformaID,
                'cantidad_contenedores' : containersproforma,
            });

          const resultado =  await handleAgregar('addbookingproforma',data);
          if(resultado==="Agregado correctamente"){
            fetchDataBookingProformas();
                setProformaID('');
                setContainersproforma('');
          }
          alert(resultado);
      };

      const handleAgregarProducto = async () => {

        const id = nameproducto!=='' ? dataNombresProductos.find((item) => item.nombre_producto===nameproducto)?.id_producto : -1;

        print(`handleAgregarProducto containers ${containersproducto} n° proforma ${id}`);

        if(id!==-1){
        const data = JSON.stringify({
            'id_booking' : formData.id_solicitud,
            'id_producto' : id,
            'cantidad_contenedores' : containersproducto,
        });

      const resultado =  await handleAgregar('addbookingproducto',data);
      if(resultado==="Agregado correctamente"){
        //fetchDataBookingProductos();
                setContainersproducto('');
                setNameproducto('');
                setIsNameSelectedproducto(false);
      }
      alert(resultado);
    } else{ alert("No fue posible agregar")}
  };

      

      const handleEliminarBookingContenedor = async (id) => {
       const resultado = await handleEliminar(id,"delete_bookingcontenedor");
       fetchDataBookingContenedor();
       alert(resultado);
          };

          const handleEliminarBookingFecha = async (id) => {
            const resultado = await handleEliminar(id,"deletebookingfecha");
            fetchDataBookingFecha();
            alert(resultado);
               };

            
            const handleAgregarDetalle = async () => {

                const idProducto = nameproducto!=='' ? dataNombresProductos.find((item) => item.nombre_producto===nameproducto)?.id_producto : -1;
                const idProveedor = nameproveedores!=='' ? dataProveedores.find((item) => item.nombre===nameproveedores)?.id_proveedor : -1;
                const idCliente = clienteInternoId || (name !== '' ? dataClientes.find((item) => item.nombre===name)?.id_cliente : -1);
                const clienteValido = Number.isInteger(Number(idCliente)) && Number(idCliente) > 0;
        
                const cantidadNueva = Number(containers);
                if (!Number.isInteger(cantidadNueva) || cantidadNueva <= 0) {
                    alert('Ingrese una cantidad de HC válida');
                    return;
                }
                if (cantidadHCAsignada + cantidadNueva > Number(formData.cantidad)) {
                    alert(`Solo puede asignar ${cantidadHCPendiente} HC más`);
                    return;
                }

                if (!ordenCompraId) {
                    alert('Seleccione la OC a la que se asignan los HC');
                    return;
                }

                if(containers!=='' && piContratoSeleccionado && idProducto!==-1 && idProveedor!==-1 && clienteValido && Number(piContratoSeleccionado.cliente) === Number(idCliente)){
                const data = JSON.stringify({
                    'id_booking' : formData.id_solicitud,
                    'id_cliente' : idCliente,
                    'id_proveedor' : idProveedor,
                    'id_ordencompra' : Number(ordenCompraId),
                    'correlativo_contrato' : Number(piContratoSeleccionado.correlativo),
                    'id_producto' : idProducto,
                    'cantidad_contenedores' : containers,
                });
        
              const resultado =  await handleAgregar('addbookingcontenedor',data);
              if(resultado==="Agregado correctamente"){
                fetchDataBookingContenedor();
                setContainers('');
                if (!clienteInternoId) {
                    setName('');
                    setIsNameSelected(false);
                }
                setNameproveedores('');
                setIsNameSelectedproveedores(false);
                setPiContratoBusqueda('');
                setPiContratoSeleccionado(null);
                setOrdenCompraId('');
                setNameproducto('');
                setIsNameSelectedproducto(false);

              }
              alert(resultado);
            } else{ alert("No fue posible agregar, favor revisar datos")}
          };

          const handleAgregarFechas = async () => {

            if(nombreContenedor!=='' || fechaRetiro!=='' || fechaIngresoPuerto!==''){

                const data = JSON.stringify({
                    'id_booking' : formData.id_solicitud,
                    'nombre_contenedor' : nombreContenedor,
                    'fecha_retiro' : fechaRetiro==='' ? null : fechaRetiro,
                    'fecha_ingreso_puerto' : fechaIngresoPuerto==='' ? null : fechaIngresoPuerto,
                });
        
    
          const resultado =  await handleAgregar('addbookingfecha',data);
          if(resultado==="Agregado correctamente"){
            fetchDataBookingFecha();
            setnombreContenedor('');
            setfechaRetiro('');
            setfechaIngresoPuerto('');
          }
          alert(resultado);
        } else{ alert("No fue posible agregar, favor revisar datos")}
      };


      const handleChangeNombreContenedor = (e) => {
        const { name, value } = e.target;
        setnombreContenedor(value);
    };
    const handleChangefechaRetiro = (e) => {
        const { name, value } = e.target;
        setfechaRetiro(value);
    };
    const handleChangefechaIngresoPuerto = (e) => {
        const { name, value } = e.target;
        setfechaIngresoPuerto(value);
    };
    const [showEditarFechaBooking, setShowEditarFechaBooking] = React.useState(false);
      
    const handleCloseEditarFechaBooking = () => setShowEditarFechaBooking(false);
    const handleShowEditarFechaBooking = () => setShowEditarFechaBooking(true);
const EditarFechaBooking = () => {

      
        return (
          <>
           <button  style={{ flex: 1, marginRight: 10 }}
                                              className='btn btn-outline-warning'
                                                 onClick={() => {
                                                    handleShowEditarFechaBooking();
                                                          }}>
                                                                        <LuPencilLine />
                                                                    </button>
      
            <Modal show={showEditarFechaBooking} onHide={handleCloseEditarFechaBooking} backdrop="static">
              <Modal.Header closeButton>
                <Modal.Title>Editar Fecha Booking</Modal.Title>
              </Modal.Header>
              <Modal.Body>
           
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseEditarFechaBooking}>
                  Volver
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        );
      };

      const handleModificarFechaBooking = () => {};

    return (
        <Modal dialogClassName="my-modal" size='xl' aria-labelledby="contained-modal-title-vcenter"
        centered show={show} onHide={handleClose} backdrop="static">
              <Modal.Header closeButton>
                <Modal.Title>{formData.nro_booking.trim()==='' ? 'Gestión de Booking' : `Gestión de Booking N° ${formData.nro_booking}`}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
              {loading  ? (
                            <div className="text-center">
                                <Spinner animation="border" role="status" />
                                <span className="sr-only">Cargando...</span>
                            </div>
                        ) : ( <><Form onSubmit={handleSubmit}>         
                    
   <div className="">
  <div className="row">
    <div className="col-4">
    <div className="mb-3">
                                <label className="form-label">Solicitud Interna Asociada</label>
                                <h4>{formData.solicitud_interna.codigo}</h4>
                            </div>
        </div>
        <div className="col-4">
        <div className="mb-3">
                                <label className="form-label">Estado de Booking {formData.estado.toString()==='0'? '🔴' : formData.estado.toString()==='1' ? '🟡' : formData.estado.toString()==='2' ? '🔵' : formData.estado.toString()==='3' ? '🟢' : formData.estado.toString()==='-1' ? '⚫' : formData.estado===99 ? '⚪' : ''}</label>
                                <select className="form-select" name="estado" onChange={handleChange} value={formData.estado}
                                 style={{backgroundColor:'black !important'}}>
                                    <option key="Confirmado" value="2">Confirmado</option>
                                    <option key="Embarcado" value="3">Embarcado</option>   
                                    <option key="Cancelado" value="-1">Cancelado</option>
                                    <option key="Transferencia" value="99">Transferencia</option>   

                                </select>
                            </div>
        </div>
        <div className="col-4 text-center">
            <Button variant="primary" size="lg" onClick={handleSubmit} style={{marginTop:5}}>
                        Actualizar Booking
                        </Button>
                        <div>{erroresForm}</div>
</div>
       <p></p>
       <hr></hr>
        </div>
        <div className="row">
    <div className="col-md-1" style={{width: '12%'}}>   
    <div className="mb-3">
                                <label className="form-label">N° Booking</label>
                                <input type="text" step="0.01" className="form-control" name="nro_booking" onChange={handleChange} value={formData.nro_booking} />
                            </div>      
                                
    </div>
    
    <div className="col-md-1" style={{width: '12%'}}>
    <div className="mb-3">
                                <label className="form-label">FFW</label>
                                <select
                                    className="form-select"
                                    name="id_ffw"
                                    onChange={(e) => handleChange({ target: { name: "id_ffw", value: e.target.value || null } })}
                                    value={formData.id_ffw || ""}
                                >
                                    {ffw.map((item) => (
                                        <option key={item.id_ffw} value={item.id_ffw}>
                                            {item.nombre}
                                        </option>
                                    ))}
                                </select>
                            </div>
    </div>
    <div className="col-md-1" style={{width: '12%'}}>
    {formData.id_ffw === null || formData.id_ffw === "" ? (
                                <div className="mb-3">
                                    <label className="form-label">Carrier</label>
                                    <select
                                        className="form-select"
                                        name="id_carrier"
                                        onChange={handleChange}
                                        value={formData.id_carrier}
                                    >
                                        <option value="">Seleccione un Carrier</option>
                                        {carriers
                                            .filter((carrier) => carrier.tipo === 2) // Filtra los carriers tipo 2
                                            .map((item) => (
                                                <option key={item.id_carrier} value={item.id_carrier}>
                                                    {item.nombre}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                            ) : (
                                <div className="mb-3">
                                    <label className="form-label">Carrier</label>
                                    <select
                                        className="form-select"
                                        name="id_carrier"
                                        onChange={handleChange}
                                        value={formData.id_carrier}
                                    >
                                        <option value="">Seleccione un Carrier</option>
                                        {carriers
                                            .filter((carrier) => carrier.tipo === 1) // Filtra los carriers tipo 1
                                            .map((item) => (
                                                <option key={item.id_carrier} value={item.id_carrier}>
                                                    {item.nombre}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                            )}
                           
    </div>
    
  <div className="col-md-1" style={{width: '6%'}}>
  <div className="mb-3">
                                <label className="form-label">FTO</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="ftorigen"
                                    onChange={handleChange}
                                    value={formData.ftorigen}
                                    placeholder="Días"
                                    required
                                />
                            </div>
 
  </div>
  <div className="col-md-1" style={{width: '6%'}}>
  <div className="mb-3">
                                <label className="form-label">FTD </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="ftdestino"
                                    onChange={handleChange}
                                    value={formData.ftdestino}
                                    placeholder="Días"
                                    required
                                />
                            </div>
  </div>
  <div className="col-md-1" style={{width: '11%'}}>
  <div className="mb-3">
                                <label className="form-label">DLD</label>
                                <DateInput name="dld" onChange={handleChange} value={formData.dld} />
                            </div>
  </div>
  <div className="col-md-1" style={{width: '12%'}}>
  <div className="mb-3">
                                <label className="form-label">Nave</label>
                                <input type="text"  className="form-control" name="nave" onChange={handleChange} value={formData.nave} required />
                            </div>
    </div>
    <div className="col-md-1" style={{width: '11%'}}>
    
    <div className="mb-3">
                                <label className="form-label">DLC</label>
                                <DateInput name="dlc" onChange={handleChange} value={formData.dlc} />
                            </div>
                           
                           
    </div>
    <div className="col-md-1" style={{width: '11%'}}>
    <div className="mb-3">
                                <label className="form-label">ETD</label>
                                <DateInput name="etd" onChange={handleChange} value={formData.etd} required />
                            </div>
    </div>
    <div className="col-md-1" style={{width: '6%'}}>
    <div className="mb-3">
                                <label className="form-label">HC</label>
                                <input type="number" className="form-control" name="cantidad" onChange={(e) => handleChangeCantidad(e, 100)} value={formData.cantidad} min="1" maxLength="2"  required />
                            </div>
                           
    </div>
  </div>
  <div className="row">
 {/*} <div className="col">
  <div className="mb-3">
        <label className="form-label">Estado de BL</label>
              <input type="date" defaultValue='' className="form-control" name="estado_bl" onChange={handleChange} value={formData.estado_bl}/>
    </div>
  </div> */}
   <div className="col-md-1" style={{width: '11%'}}>
    
    <div className="mb-3">
                                <label className="form-label">ETA</label>
                                <DateInput name="eta" onChange={handleChange} value={formData.eta} />
                            </div>
                           
                           
    </div>
  <div className="col">    <div className="mb-3">
                                <label className="form-label">Categoría</label>
                                <select className="form-select" name="categoria_booking" onChange={handleChange} value={formData.categoria_booking}>
                                <option value="-1">Seleccione categoría</option>
                                <option key="Lamina" value="1">
                                Lamina</option>  
                                <option key="Madera" value="2">
                                 Madera</option>
                                 <option key="Terciado" value="3">
                                 Terciado</option>   
                                    

                                </select>
                            </div>
                            </div>
                            <div className="col">   <div className="mb-3">
                                <label className="form-label">Cross Docking</label>
                                <select className="form-select" name="cross_docking" onChange={handleChange} value={formData.cross_docking}>
                                <option value="-1">Seleccione si es Cross Docking</option>
                                <option key="Si" value="si">
                                Si</option>  
                                <option key="No" value="no">
                                 No</option> 
                                </select>
                            </div>
                            </div>                         
  <div className="col">   <div className="mb-3">
                                <label className="form-label">MAPA</label>
                                <select className="form-select" name="mapa" onChange={handleChange} value={formData.mapa}>
                                <option value="-1">Seleccione si es MAPA</option>
                                <option key="Si" value="si">
                                Si</option>  
                                <option key="No" value="no">
                                 No</option> 
                                </select>
                            </div>
                            </div>
                            {formData.estado.toString()==='3' ? (
                            <div className="col">   <div className="mb-3">
                                <label className="form-label">Invoice</label>
                                <input type="number" className="form-control" onChange={(e) => handleChangeCantidad(e, 10000)} name="invoice" value={formData.invoice} disabled={Number(formDataAntigua.estado) !== 3} />
                                {Number(formDataAntigua.estado) !== 3 && <Form.Text muted>Se habilitará después de guardar el booking como Embarcado.</Form.Text>}
                            </div>
                            </div>) : <></>}
  <div className="col">
  <div className="col text-center">
                            
                            <GuardarArchivo/>

                            </div>
  </div>
  </div>
        </div> </Form>
        <p></p>
<hr></hr>
<Accordion defaultActiveKey={desde==='bookingexterno' ? "0" : "-1"}>
      <Accordion.Item eventKey="0">
        <Accordion.Header>Fechas de Booking</Accordion.Header>
        <Accordion.Body>
        {desde==='bookingexterno' ? (
        <Form>
            <Row>
            <Form.Group className="typeahead-form-group position-relative" as={Col}>
           <Form.Label>Nombre de Contenedor</Form.Label>
           <Form.Control
          type="text"                      
          onChange={handleChangeNombreContenedor}
          value={nombreContenedor}
        />
      </Form.Group>
            <Form.Group className="typeahead-form-group" as={Col}>
           <Form.Label>Fecha de Retiro</Form.Label>
        <DateInput
          onChange={handleChangefechaRetiro}
          value={fechaRetiro}
        />
      </Form.Group>
      <Form.Group className="typeahead-form-group" as={Col}>
           <Form.Label>Fecha de Ingreso al Puerto</Form.Label>
        <DateInput
          onChange={handleChangefechaIngresoPuerto}
          value={fechaIngresoPuerto}
        />
      </Form.Group>
      <Form.Group as={Col} xs="auto">
           <Button variant="primary" onClick={handleAgregarFechas} style={{marginTop:25}}>
                       Guardar
                       </Button>  </Form.Group>
      </Row>
      </Form>
      ) :(<></>)}   
      <p></p>
    
                                {dataBookingFecha.length>0 ? (<Table striped bordered hover>
                                    <tbody>
                                    <tr>
                                    <th>Nombre Contenedor</th>
                                    <th>Fecha de Retiro</th>
                                    <th>Fecha de Ingreso al Puerto</th>
                                    {desde==='bookingexterno' ? ( <th>Acciones</th>) : (<></>) }                                   
                                     </tr>
                             
                                    {dataBookingFecha.map((object, i) => <tr><td>{object.nombre_contenedor}</td>
                                    <td>{object.fecha_retiro}</td><td>{object.fecha_ingreso_puerto}</td>
                                    {desde==='bookingexterno' ? (  <td>

                                 {/*  <EditarFechaBooking/> */}
                                    
                                      
                                        <button 
                                              className='btn btn-outline-danger'
                                                 onClick={() => {
                                                    if (window.confirm('¿Estás seguro de eliminar este registro?')) {
                                                        handleEliminarBookingFecha(object.id);
                                                           }
                                                          }}
                                                                    >
                                                                        <IoTrashOutline />
                                                                    </button></td>) : (<></>)}
                                        </tr>)}

                                    </tbody>
                               </Table>) : (<div>No hay datos que mostrar</div>) }
                               
   
        </Accordion.Body>
      </Accordion.Item>
      </Accordion>
<p></p>
<hr></hr>
        <Card>
        <Card.Header as="h5">Asignación de Booking</Card.Header>
            <Card.Body> 
                {desde==='solicitudesinternas' ? (
        <Form>
            <Row>
            <Form.Group className="typeahead-form-group" as={Col}>
           <Form.Label>Cliente </Form.Label>
        <Form.Control
          type="text"
          autoComplete="off"
          placeholder="Buscar Cliente"                              
          onChange={(e) => handleInputChange(e,'cliente')}
          value={name}
          readOnly={Boolean(clienteInternoId)}
        />
        <ListGroup className="typeahead-list-group">
          {!isNameSelected &&
            results.length > 0 &&
            results.map((result) => (
              <ListGroup.Item
                key={result.id_cliente}
                className="typeahead-list-group-item"
                onClick={() => onNameSelected(result.nombre,'cliente')}
              >
                {result.nombre}
              </ListGroup.Item>
            ))}
        </ListGroup>
      </Form.Group>


            <Form.Group className="typeahead-form-group position-relative" as={Col}>
           <Form.Label>PI / Contrato</Form.Label>
        <Form.Control
          type="text"
          autoComplete="off"
          placeholder={clienteAsignacionId ? 'Buscar PI (ej. CTB 56-25)' : 'Seleccione un cliente primero'}
          disabled={!clienteAsignacionId}
          onChange={(e) => {
            setPiContratoBusqueda(e.target.value);
            setPiContratoSeleccionado(null);
            setPiContratoDropdownAbierto(true);
          }}
          onFocus={() => setPiContratoDropdownAbierto(true)}
          onBlur={() => setTimeout(() => setPiContratoDropdownAbierto(false), 150)}
          onKeyDown={handlePiContratoKeyDown}
          value={piContratoBusqueda}
          role="combobox"
          aria-autocomplete="list"
          aria-expanded={piContratoDropdownAbierto}
        />
        <ListGroup
          className="typeahead-list-group position-absolute w-100 shadow"
          role="listbox"
          style={{ top: 'calc(100% + 2px)', left: 0, maxHeight: 220, overflowY: 'auto', zIndex: 1060 }}
        >
          {piContratoDropdownAbierto && !piContratoSeleccionado && resultadosProformas.length > 0 &&
            resultadosProformas.map((proforma) => (
              <ListGroup.Item
                key={proforma.id_proforma}
                className="typeahead-list-group-item"
                role="option"
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => seleccionarProforma(proforma)}
              >
                {proforma.id_pi}
              </ListGroup.Item>
            ))}
          {piContratoDropdownAbierto && clienteAsignacionId && !piContratoSeleccionado && resultadosProformas.length === 0 && (
            <ListGroup.Item className="text-muted">
              {proformasDelCliente.length === 0 ? 'Este cliente no tiene PI registradas' : 'No se encontraron PI'}
            </ListGroup.Item>
          )}
        </ListGroup>
      </Form.Group>

      <Form.Group className="typeahead-form-group position-relative" as={Col}>
           <Form.Label>Producto </Form.Label>
        <Form.Control
          type="text"
          autoComplete="off"
          placeholder={piContratoSeleccionado ? 'Buscar producto de la PI' : 'Seleccione una PI primero'}
          disabled={!piContratoSeleccionado}
          onChange={(e) => handleInputChange(e,'producto')}
          onFocus={() => {
            setProductoDropdownAbierto(true);
            const productosPermitidos = new Set(
              (piContratoSeleccionado?.productos || []).map(id => Number(id))
            );
            setResultsproducto(dataNombresProductos.filter(item => productosPermitidos.has(Number(item.id_producto))));
          }}
          onBlur={() => setTimeout(() => setProductoDropdownAbierto(false), 150)}
          value={nameproducto}
          role="combobox"
          aria-autocomplete="list"
          aria-expanded={productoDropdownAbierto}
        />
        <ListGroup
          className="typeahead-list-group position-absolute w-100 shadow"
          role="listbox"
          style={{ top: 'calc(100% + 2px)', left: 0, maxHeight: 220, overflowY: 'auto', zIndex: 1060 }}
        >
          {productoDropdownAbierto && !isNameSelectedproducto &&
            resultsproducto.length > 0 &&
            resultsproducto.map((result) => (
              <ListGroup.Item
                key={result.id_producto}
                className="typeahead-list-group-item"
                role="option"
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => onNameSelected(result.nombre_producto,'producto')}
              >
                {result.nombre_producto}
              </ListGroup.Item>
            ))}
          {productoDropdownAbierto && piContratoSeleccionado && resultsproducto.length === 0 && (
            <ListGroup.Item className="text-muted">
              {dataNombresProductos.some(item => (piContratoSeleccionado.productos || []).some(id => Number(id) === Number(item.id_producto)))
                ? 'No se encontraron productos'
                : 'Esta PI no tiene productos disponibles'}
            </ListGroup.Item>
          )}
        </ListGroup>
      </Form.Group>

      <Form.Group as={Col}>
        <Form.Label>OC de la PI</Form.Label>
        <Form.Select
          value={ordenCompraId}
          disabled={!piContratoSeleccionado}
          onChange={(e) => seleccionarOrdenCompra(e.target.value)}
        >
          <option value="">
            {!piContratoSeleccionado ? 'Seleccione una PI primero' : ordenesCompraPi.length ? 'Seleccione una OC' : 'La PI no tiene OC vinculadas'}
          </option>
          {ordenesCompraPi.map((oc) => (
            <option key={oc.id_ordencompra} value={oc.id_ordencompra}>{oc.id_oc} · {oc.proveedor}</option>
          ))}
        </Form.Select>
      </Form.Group>

           <Form.Group className="typeahead-form-group position-relative" as={Col}>
           <Form.Label>Proveedor </Form.Label>
        <Form.Control
          type="text"
          autoComplete="off"
          placeholder="Buscar Proveedor"                              
          onChange={(e) => handleInputChange(e,'proveedor')}
          onFocus={() => {
            if (!isNameSelectedproveedores && resultsproveedores.length > 0) {
              setProveedorDropdownAbierto(true);
            }
          }}
          onBlur={() => setTimeout(() => setProveedorDropdownAbierto(false), 150)}
          value={nameproveedores}
          role="combobox"
          aria-autocomplete="list"
          aria-expanded={proveedorDropdownAbierto}
        />
        <ListGroup
          className="typeahead-list-group position-absolute w-100 shadow"
          role="listbox"
          style={{ top: 'calc(100% + 2px)', left: 0, maxHeight: 220, overflowY: 'auto', zIndex: 1060 }}
        >
          {proveedorDropdownAbierto && !isNameSelectedproveedores &&
            resultsproveedores.length > 0 &&
            resultsproveedores.map((result) => (
              <ListGroup.Item
                key={result.id_proveedor}
                className="typeahead-list-group-item"
                role="option"
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => onNameSelected(result.nombre,'proveedor')}
              >
                {result.nombre}
              </ListGroup.Item>
            ))}
          {proveedorDropdownAbierto && !isNameSelectedproveedores && nameproveedores.length > 1 && resultsproveedores.length === 0 && (
            <ListGroup.Item className="text-muted">No se encontraron proveedores</ListGroup.Item>
          )}
        </ListGroup>
      </Form.Group>

         <Form.Group as={Col}>
        <Form.Label>Cantidad HC (disponibles: {cantidadHCPendiente})</Form.Label>
        <Form.Control type="number" min="1" max={cantidadHCPendiente} step="1" placeholder="Cant. Contenedores" value={containers} onChange={(e) => handleChangeConteiner(e,'cliente')} disabled={cantidadHCPendiente === 0} />
      </Form.Group>

      <Form.Group as={Col} xs="auto">
           <Button variant="primary" onClick={handleAgregarDetalle} style={{marginTop:25}}>
           Guardar
                       </Button>  </Form.Group>
      </Row>
            </Form>       ) :(<></>)}   
<p></p>
    
                                {dataBookingContenedor.length>0 ? (<Table striped bordered hover>
                                    <tbody>
                                    <tr>
                                    <th>Cliente</th>
                                    <th>Contrato</th>
                                    <th>Producto</th>
                                    <th>Proveedor</th>
                                    <th>OC</th>
                                    <th>HC</th>
                                    {desde==='solicitudesinternas' ? ( <th>Acciones</th>) : (<></>)}
                                    </tr>
                             
                                    {dataBookingContenedor.map((object, i) => <tr key={object.id}><td>{dataClientes.find((item) => item.id_cliente===object.id_cliente)?.nombre}</td><td>{mostrarContratoAsignado(object)}</td>
                                    <td>{dataNombresProductos.find((item) => item.id_producto===object.id_producto)?.nombre_producto}</td>
                                    <td>{dataProveedores.find((item) => item.id_proveedor===object.id_proveedor)?.nombre}</td><td>{object.id_oc || '—'}</td><td>{object.cantidad_contenedores}</td>
                                    {desde==='solicitudesinternas' ? ( <td>

                                      
                                        <button 
                                              className='btn btn-outline-danger'
                                                 onClick={() => {
                                                    if (window.confirm('¿Estás seguro de eliminar este registro?')) {
                                                        handleEliminarBookingContenedor(object.id);
                                                           }
                                                          }}
                                                                    >
                                                                        <IoTrashOutline />
                                                                    </button></td>) : (<></>)}
                                        </tr>)}

                                    </tbody>
                               </Table>) : (<div>No hay datos que mostrar</div>) }
                               </Card.Body>
                               </Card>
       <p></p>

        <Accordion defaultActiveKey="-2">
      <Accordion.Item eventKey="0">
        <Accordion.Header>Historia<Badge bg="danger" style={{marginLeft: 10}}>
                                            </Badge></Accordion.Header>
        <Accordion.Body>
        <Table striped bordered hover>
                                <tbody>
                                    <tr>
                                    <th>Usuario Creador</th>
                                    <th>Fecha Creación</th>
                                    </tr>
                                    <tr>
                                    <td>{usuarioCreador}</td>
                                    <td>{formData.fecha_creacion}</td>
                                    </tr>
                                    </tbody>
                                    </Table>
                                {dataHistoria.length>0 ? (<Table striped bordered hover>
                                    <tbody>
                                    <tr>
                                    <th>Usuario Actualiza</th>
                                    <th>Fecha</th>
                                    <th>Datos</th>
                                    </tr>
                             
                                    {dataHistoria.map((object, i) => <tr><td>{object.usuario_modifica.split('@')[0]}</td><td>{object.fecha}</td>
                                    <td>
                                    {Object.keys(object.objeto_anterior).map((key)=>{
                                         if(key!=='solicitud_interna' && object.objeto_anterior[key]!==object.objeto_actual[key])
                                            return (<div><b>{capitalizeFirstLetter(key.replace('_',' '))}</b><br></br>Antiguo: {(object.objeto_anterior[key]===null ? 'sin dato' : object.objeto_anterior[key]===true ? 'activado' : object.objeto_anterior[key]===false ? 'desactivado' : key==='estado' ? (object.objeto_anterior[key].toString()==="0" ? 'Pendiente' : object.objeto_anterior[key].toString()==="1" ? 'Solicitado' : object.objeto_anterior[key].toString()==="2" ? 'Confirmado' : object.objeto_anterior[key].toString()==="3" ? 'Embarcado' : object.objeto_anterior[key].toString()==="-1" ? 'Cancelado' : object.objeto_anterior[key].toString()==="99" ? 'Transferencia' : 'Sin estado') : key==='categoria_booking' ? (object.objeto_anterior[key].toString()==="1" ? 'Lamina' : object.objeto_anterior[key].toString()==="2" ? 'Madera' : object.objeto_anterior[key].toString()==="3" ? 'Terciado' : 'Sin categoria') : key==='id_ffw' ? (ffw.find(f => f.id_ffw.toString() === object.objeto_anterior[key].toString())?.nombre || '') : key==='id_carrier' ? (carriers.find(f => f.id_carrier.toString() === object.objeto_anterior[key].toString())?.nombre || '') : object.objeto_anterior[key])+""} , Nuevo: {(object.objeto_actual[key]===null ? 'sin dato' : object.objeto_actual[key]===true ? 'activado' : object.objeto_actual[key]===false ? 'desactivado' : key==='estado' ? (object.objeto_actual[key].toString()==="0" ? 'Pendiente' : object.objeto_actual[key].toString()==="1" ? 'Solicitado' : object.objeto_actual[key].toString()==="2" ? 'Confirmado' : object.objeto_actual[key].toString()==="3" ? 'Embarcado' : object.objeto_actual[key].toString()==="-1" ? 'Cancelado' : object.objeto_actual[key].toString()==="99" ? 'Transferencia' : 'Sin estado') : key==='categoria_booking' ? (object.objeto_actual[key].toString()==="1" ? 'Lamina' : object.objeto_actual[key].toString()==="2" ? 'Madera' : object.objeto_actual[key].toString()==="3" ? 'Terciado' : 'Sin categoria') : key==='id_ffw' ? (ffw.find(f => f.id_ffw.toString() === object.objeto_actual[key].toString())?.nombre || '') : key==='id_carrier' ? (carriers.find(f => f.id_carrier.toString() === object.objeto_actual[key].toString())?.nombre || '') : object.objeto_actual[key])+""}</div>);
                                    })}
                                    </td>
                                        </tr>)}

                                    </tbody>
                               </Table>) : (<></>) }
                               
        </Accordion.Body>
      </Accordion.Item>
      </Accordion>

      </>)}      
                 


              </Modal.Body>
            </Modal>
    );
};

export default GestionCPO;
